export const CVScoreBreakdown = ({ employee }) => {
  const promoters = employee.cv_promoters || 0;
  const detractors = employee.cv_detractors || 0;
  const passives = employee.cv_passives || 0;
  const nps = employee.nps_score != null ? Number(employee.nps_score) : null;
  const npsPts = nps != null ? Math.min(nps / 10, 10) : 0;
  const total = (employee.cv_score || 0).toFixed(1);

  return (
    <div
      className="rounded-lg bg-slate-800/80 print:bg-slate-100 border border-slate-700 print:border-slate-300 px-4 py-3 text-xs space-y-1.5"
      data-testid={`cv-breakdown-${employee.name || employee.id}`}
    >
      <div className="font-semibold text-slate-200 print:text-slate-800 text-[13px]">
        How this CV score is calculated
      </div>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 font-mono">
        <span className="text-blue-400 print:text-blue-700">
          NPS {nps != null ? `${nps.toFixed(0)}%` : "—"} ÷ 10 = +{npsPts.toFixed(1)} pts
        </span>
        <span className="text-slate-500">(max 10)</span>
        <span className="text-slate-500">+</span>
        <span className="text-green-400 print:text-green-700">
          {promoters} promoter{promoters === 1 ? "" : "s"} × 1 = +{promoters.toFixed(1)}
        </span>
        <span className="text-slate-500">−</span>
        <span className="text-red-400 print:text-red-700">
          {detractors} detractor{detractors === 1 ? "" : "s"} × 2 = −{(detractors * 2).toFixed(1)}
        </span>
        <span className="text-slate-500">=</span>
        <span className="font-bold text-amber-400 print:text-amber-700">{total}</span>
      </div>
      {passives > 0 && (
        <div className="text-slate-400 print:text-slate-600">
          {passives} passive review{passives === 1 ? "" : "s"} (7–8 rating) count 0 pts but lower the NPS % — that's
          why more reviews doesn't always mean a higher score.
        </div>
      )}
    </div>
  );
};
